import axiosInstance from "./axiosInstance";

export const fetchActiveProviders = async (service) => {
  try {
    const response = await axiosInstance.get("/api/providers/active", {
      params: service ? { service } : undefined,
    });
    return {
      success: true,
      data: response?.data?.data || response?.data,
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message || "Failed to load active providers",
      data: { providers: [] },
    };
  }
};
